import {
	unstableAlertRtl,
	unstableAvatarGroupRtl,
	// unstableBadgeRtl,
	unstableButtonRtl,
	unstableNotificationRtl,
	unstableMessageRtl,
	unstableDataTableRtl,
	unstableButtonGroupRtl,
	unstableCardRtl,
	unstableCheckboxRtl,
	unstableCollapseRtl,
	unstableCollapseTransitionRtl,
	unstableDialogRtl,
	unstableDrawerRtl,
	unstableDynamicInputRtl,
	unstableFlexRtl,
	unstableInputRtl,
	unstableInputNumberRtl,
	unstableListRtl,
	unstablePaginationRtl,
	unstableRadioRtl,
	unstableSelectRtl,
	unstableSpaceRtl,
	unstableStatisticRtl,
	unstableStepsRtl,
	unstableTableRtl,
	unstableTagRtl,
	unstableThingRtl,
	unstableTreeRtl,
	unstableRowRtl,
	unstableScrollbarRtl
} from "naive-ui"
import type { RtlItem } from "naive-ui/es/config-provider/src/internal-interface"

const rtlStyles: RtlItem[] = [
	unstableAlertRtl,
	unstableAvatarGroupRtl,
	// unstableBadgeRtl,
	unstableButtonRtl,
	unstableNotificationRtl,
	unstableMessageRtl,
	unstableDataTableRtl,
	unstableButtonGroupRtl,
	unstableCardRtl,
	unstableCheckboxRtl,
	unstableCollapseRtl,
	unstableCollapseTransitionRtl,
	unstableDialogRtl,
	unstableDrawerRtl,
	unstableDynamicInputRtl,
	unstableFlexRtl,
	unstableInputRtl,
	unstableInputNumberRtl,
	unstableListRtl,
	unstablePaginationRtl,
	unstableRadioRtl,
	unstableSelectRtl,
	unstableSpaceRtl,
	unstableStatisticRtl,
	unstableStepsRtl,
	unstableTableRtl,
	unstableTagRtl,
	unstableThingRtl,
	unstableTreeRtl,
	unstableRowRtl,
	unstableScrollbarRtl
]

export { rtlStyles }
